import React from 'react'
import styled from 'styled-components'
import Covervideo from '../componenets/Covervideo'
import Logo from '../componenets/Logo'
import Navbar from '../componenets/Navbar'


const Section = styled.section`
position:relative;
min-height:100vh;
overflow:hidden;
`
const Home = () => {
  return ( 
    <Section id='home'>
      <Covervideo/>
      <Logo />
      <Navbar />
    </Section>
  )
}

export default Home
